// extracted by mini-css-extract-plugin
module.exports = {"theComp":"SwiperJpB_theComp___ELCp"};